import { formatDate, showLastUsedData } from '@utils/index';

export const createCellValue = (
  property: string,
  data: any,
  index: number,
  isMobile = true,
  formatedValue: string
) => {
  const value = data[index][property];

  switch (property) {
    case 'licenseType':
      return (
        <>
          <span>{isMobile ? value : formatedValue}</span>
          {data[index]['isOverassigned'] && (
            <span className="ml-1 rounded-[20px] border border-warningColor-100 bg-warningColor-10 pb-0 pl-2 pr-2 pt-0 text-14 text-interfaceColor-100">
              Overassigned
            </span>
          )}
        </>
      );
    case 'lastUsed':
      return (
        <>
          <span>{formatDate(value)}</span>
          {showLastUsedData(data[index]['overNDaysAgo'])}
        </>
      );
    case 'assignedTo':
      return (
        <>
          <span>{value}</span>
          <div className="flex flex-col">
            <span className="text-14 tracking-wide text-interfaceColor-80">
              {data[index]['expiryDate'] &&
                `Will be disabled ${formatDate(data[index]['expiryDate'])}`}
            </span>
          </div>
        </>
      );
    case 'assignmentDate':
      return (
        <>
          <span>{formatDate(value)}</span>
        </>
      );
    case 'expiryDate':
      return (
        <>
          <span>{formatDate(value)}</span>
        </>
      );
      case 'vendor':
        return (
          <>
            <span>{value ?? 'No data available'}</span>
          </>
        );
  }
};
